export default {
    SEAT_OR_TICKET: 1,
    MILES_A_SMILES: 2,
    FORGOT_PASSCODE: 3,
    OTHER_LOGIN: 4
}

export const getName = (number) => {
    if (number === 1) return "SEAT_OR_TICKET";
    else if (number === 2) return "MILES_A_SMILES";
    else if (number === 3) return "FORGOT_PASSCODE";
    else if (number === 4) return "OTHER_LOGIN";
}
